module.exports = __webpack_public_path__ + "images/b72aca4710712124cedfb29708dc2c59.png";